import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 15;
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 5}px;
`;

export const ButtonContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.CONSTANTS.XR * 3}px;
  width: 100%;
  height: 100%;
`;

export const ButtonIcon = styled.img`
  width: 28px;
`;
